import { useTranslations } from "@Context/TranslationContext/TranslationContext";

type TeaserProps = {
  title: string;
  redirectUrl: string;
  children: React.ReactNode;
  testId: string;
  headerTestId: string;
};

export const TeaserWrapper = ({
  title,
  redirectUrl,
  children,
  testId,
  headerTestId,
}: TeaserProps) => {
  const { t } = useTranslations();

  return (
    <a
      href={redirectUrl}
      data-testid={testId}
      aria-label={t("teaser.linkTo", { title })}
      className="m:z-10 m:min-w-[304px] m:cursor-pointer m:overflow-hidden m:rounded-sm m:bg-blue-750 m:p-4 m:text-neutral-white m:no-underline m:hover:bg-blue-800 m:hover:text-neutral-white m:active:bg-blue-800 m:lg:max-w-[359px] m:lg:min-w-[296px] m:xl:min-w-[378.66px] m:dark:bg-blue-850 m:dark:hover:bg-blue-750 m:dark:active:bg-blue-750">
      <div aria-hidden className="m:h-full">
        <h2
          data-testid={headerTestId}
          className="m:text-xl m:leading-tight m:font-normal! m:tracking-0.4 m:text-neutral-white m:hover:text-neutral-white">
          {title}
        </h2>
        {children}
      </div>
    </a>
  );
};
